import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import CircleIcon from '@mui/icons-material/Circle';
import CloseIcon from '@mui/icons-material/Close';
import EventAvailableRounded from '@mui/icons-material/EventAvailableRounded';
import HealthAndSafetyRounded from '@mui/icons-material/HealthAndSafetyRounded';
import ModeEditRounded from '@mui/icons-material/ModeEditRounded';
import PaymentsRounded from '@mui/icons-material/PaymentsRounded';
import PercentRounded from '@mui/icons-material/PercentRounded';
import TrackChangesRounded from '@mui/icons-material/TrackChangesRounded';

/** Product-specific benefit icons keyed by service name. Order matches benefitMessageIds. */
export const SERVICE_BENEFIT_ICONS = {
  zb_money_pro: [PercentRounded, TrackChangesRounded, PaymentsRounded],
  zb_website_tools_bundle: [ModeEditRounded, EventAvailableRounded, HealthAndSafetyRounded],
  website_tools_bundle: [ModeEditRounded, EventAvailableRounded, HealthAndSafetyRounded]
};

/** Product display titles for cancel flow. Match ecomm-services-ui OrderView constants (PLAN_PRODUCTS). */
export const SERVICE_DISPLAY_NAMES = {
  money_pro: 'Money Pro',
  zb_money_pro: 'Money Pro',
  website_tools_bundle: 'Domain, Email, and Website',
  zb_website_tools_bundle: 'Domain, Email, and Website'
};

/**
 * Map service id or API summary to product.name.* intl message id.
 * Shared by cancel (fallback when titleMessageId missing) and restart flows.
 */
export const SERVICE_OR_SUMMARY_TO_PRODUCT_NAME_MESSAGE_ID = {
  zb_money_pro: 'product.name.money_pro',
  zb_website_tools_bundle: 'product.name.website_tools_bundle',
  'Website tools bundle': 'product.name.website_tools_bundle',
  'Website Tools Bundle': 'product.name.website_tools_bundle'
};

/**
 * Returns product.name.* message id for a subscription service/summary, or null.
 * @param {string} [service]
 * @param {string} [summary]
 * @returns {string|null}
 */
export function getProductNameMessageId(service, summary) {
  const raw = summary || service;
  return SERVICE_OR_SUMMARY_TO_PRODUCT_NAME_MESSAGE_ID[service]
    ?? SERVICE_OR_SUMMARY_TO_PRODUCT_NAME_MESSAGE_ID[raw]
    ?? null;
}

export const DEFAULT_BENEFIT_ICON = CircleIcon;

export const VELO_AVATAR_SRC = 'https://res.cloudinary.com/zenbusiness/image/upload/v1751552559/shared-assets/s2/avatar/velo-avatar.png';
export const SUCCESS_ILLUSTRATION = 'https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/raster/successful.png';
export const ERROR_ILLUSTRATION = 'https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/raster/error-page.png';

export { ChevronLeftRoundedIcon, CloseIcon };
